import classes from './FundsBox.module.css'

const FundsBox = ({label, value, minWidth, color}) => {
    return <div className={`${classes.container} ${color ? classes[color] : ''}`} style={{minWidth: minWidth}}>
        <div className={classes.container_inner}>
            {label && <div className={classes.label} >{label}</div>}
            {value && <div className={classes.input}>{value}</div>}
        </div>
    </div>
}

export default FundsBox